import { VerificationStatus } from "shared/types";
import { Cell } from "../Cell";
import { IDVstatus } from "../IDVstatus";
import { ReportStatusBadge } from "../ReportStatusBadge";
import { Verification } from "../../types";
import { useAuthContext } from "providers/Auth";

interface IdentityVerificationCellProps {
  verification: Verification;
  isIdentityVerificationOverrideRequired?: boolean;
}

export const IdentityVerificationCell = ({
  verification,
  isIdentityVerificationOverrideRequired
}: IdentityVerificationCellProps) => {
  const { permissions } = useAuthContext();
  const shouldShowReportBadge = [
    VerificationStatus.Pending,
    VerificationStatus.Failed
  ].includes(verification.status);

  return (
    <Cell
      isDataCell
      className="relative"
      isPermitted={permissions.canAccessReports.identityVerification}
      showRestrictedFlag={!permissions.canAccessReports.identityVerification}
    >
      <IDVstatus status={verification.status} />
      {shouldShowReportBadge ? (
        <ReportStatusBadge
          verificationStatus={verification.status}
          isActionRequired={isIdentityVerificationOverrideRequired}
        />
      ) : null}
    </Cell>
  );
};
